import Vue from "vue";
import App from "./App.vue";
import axios from 'axios';
import VueAxios from 'vue-axios';
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store/store";
import Vuebar from "vuebar";
import "./plugins/base";
import VueSkycons from "vue-skycons";
import VueFeather from "vue-feather";
import InstantSearch from "vue-instantsearch";
import moment from 'moment'
import * as VueGoogleMaps from 'vue2-google-maps'





Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY hh:mm')
  }
});


Vue.use(VueAxios, axios);
Vue.use(VueFeather);
Vue.use(VueSkycons, {
  color: "#1e88e5",
});
Vue.use(InstantSearch);
Vue.config.productionTip = false;
Vue.use(Vuebar);

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyATy54MEcrbt-EclXeyrP22KlUzIjCKVAs',
    libraries: 'places',
  }
});



new Vue({
  vuetify,
  store,
  router,
  
  render: (h) => h(App),
}).$mount("#app");
console.log('Revisar');
console.log('Token'+ store.state.token);
if(store.state.token == null){
router.push({ path: "/authentication/login" });
console.log('Corriendo');
}
